import React, { useRef, useState } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, TextField, Grid, IconButton, Chip } from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import { selectWebsiteSettings } from "../../../Redux/Slices/websiteSettingsSlice";
import { useSelector } from "react-redux";
import { BarChart, Gauge, gaugeClasses } from "@mui/x-charts";

export default function RankCardPage() {
    const cardRef = useRef();
    const page1Ref = useRef();
    const page2Ref = useRef();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const navigate = useNavigate()
    const websiteSettings = useSelector(selectWebsiteSettings);

    const student = {
        name: "V.P. MAGATHI YAVIRA",
        rollNumber: "8895",
        classSec: "LKG - A",
        exam: "1st Mid term Examination",
        marks: [
            { subject: "Tamil", score: 50, total: 50 },
            { subject: "English", score: 48, total: 50 },
            { subject: "Mathematics", score: 48, total: 50 },
            { subject: "General Awareness", score: 50, total: 50 },
            { subject: "Rhymes", score: 50, total: 50 },
            { subject: "Conversation & Health talk Hindi", score: 50, total: 50 },
        ],
        marks1: [
            { exam: "1St Mid Term Exam", score: 296, total: 300, grade: "A1" },
            { exam: "1St Term Exam", score: 0, total: 300 },
            { exam: "2nd Mid Term Exam", score: 0, total: 300 },
            { exam: "2nd Term Exam", score: 0, total: 300 },
            { exam: "3nd Mid Term Exam", score: 0, total: 300 },
            { exam: "3rd Term Exam", score: 0, total: 300 },
        ],
        totalMarks: 296,
        percentage: 98,
    };
    const marks = 98;
    const getColor = (value) => {
        if (value >= 90) return 'green';
        if (value >= 75) return 'yellow';
        if (value >= 50) return 'orange';
        return 'red';
    };

    const downloadPDF = async () => {
        setLoading(true);
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();

        try {
            const canvas1 = await html2canvas(page1Ref.current, {
                scale: 2,
                useCORS: true,
            });
            const img1 = canvas1.toDataURL("image/png");
            const props1 = pdf.getImageProperties(img1);
            const h1 = (props1.height * pdfWidth) / props1.width;
            pdf.addImage(img1, "PNG", 0, 0, pdfWidth, h1);

            const canvas2 = await html2canvas(page2Ref.current, {
                scale: 2,
                useCORS: true,
            });
            const img2 = canvas2.toDataURL("image/png");
            const props2 = pdf.getImageProperties(img2);
            const h2 = (props2.height * pdfWidth) / props2.width;
            pdf.addPage();
            pdf.addImage(img2, "PNG", 0, 0, pdfWidth, h2);

            pdf.save(`${student.name}_ProgressReport.pdf`);
        } catch (err) {
            console.error("PDF Error:", err);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Box>
            <Box sx={{
                position: "fixed",
                zIndex: 100,
                backgroundColor: "#f2f2f2",
                borderBottom: "1px solid #ddd",
                width: "100%",
                py: 1.5,
                px: 2,
            }}>
                <Grid container>
                    <Grid size={{ lg: 6 }} sx={{ display: "flex" }}>
                        <IconButton onClick={() => navigate(-1)} sx={{ width: "27px", height: "27px", marginTop: '2px', }}>
                            <ArrowBackIcon sx={{ fontSize: 20, color: "#000" }} />
                        </IconButton>
                        <Typography sx={{ fontWeight: "600", fontSize: "20px" }}>Progress Report</Typography>
                    </Grid>

                </Grid>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", paddingTop: "70px" }}>

                <Box>
                    <Paper ref={page1Ref} sx={{
                        width: "794px",
                        height: "1123px",
                        margin: "0 auto",
                        border: "1px solid #ccc",
                        overflow: "hidden",
                        border: "1px solid #ccc",
                        borderRadius: "0px",
                        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2),",
                    }}>
                        <Box sx={{ textAlign: "center", mb: 1, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#D9D9D9" }}>
                            <img src={websiteSettings.logo} width={"100px"} alt={websiteSettings.logo} />
                            <Typography variant="h6" sx={{ fontWeight: "600" }}>
                                {websiteSettings.title}
                            </Typography>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: "600" }}>STUDENT'S PROGRESS REPORT</Typography>
                        </Box>
                        <Box sx={{ px: 3, pt: 1, pb: 3 }}>
                            <Paper variant="outlined" sx={{ p: 2, mb: 1, border: "1px solid #B78B9B" }}>
                                <Grid container spacing={2}>
                                    <Grid size={{ lg: 12 }}>
                                        <Typography ><b>Student Name:</b> {student.name}</Typography>
                                        <Typography sx={{ pt: 1.3 }}><b>Student Roll Number:</b> {student.rollNumber}</Typography>
                                        <Typography sx={{ pt: 1.3 }}><b>Class & Sec:</b> {student.classSec}</Typography>
                                        <Typography sx={{ pt: 1.3 }}><b>Examination:</b> {student.exam}</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>

                            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "600", textAlign: "center" }}>MARK DETAILS</Typography>
                            <TableContainer sx={{ mb: 2, border: "1px solid #D0130E", borderRadius: "3px" }}>
                                <Table sx={{
                                    borderCollapse: "collapse",
                                    "& td, & th": {
                                        border: "1px solid #FFE6E9",
                                    },
                                }}>
                                    <TableHead>
                                        <TableRow >
                                            <TableCell sx={{ fontWeight: "600", backgroundColor: "#FFF6F7" }}>S.no</TableCell>
                                            <TableCell sx={{ fontWeight: "600", backgroundColor: "#FFF6F7" }}>Subjects</TableCell>
                                            <TableCell sx={{ fontWeight: "600", backgroundColor: "#FFF6F7" }}>Marks Scored</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {student.marks.map((m, i) => (
                                            <TableRow key={i}>
                                                <TableCell>{i + 1}</TableCell>
                                                <TableCell>{m.subject}</TableCell>
                                                <TableCell sx={{ color: "red" }}>
                                                    {m.score}/{m.total}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <Box sx={{ backgroundColor: "#FFF6F7", width: "100%" }}>
                                    <Grid container sx={{ display: "flex", justifyContent: "center" }}>
                                        <Grid size={{ xs: 8.7 }} sx={{ display: "flex", justifyContent: "center" }}>
                                            <Box sx={{ width: "100%" }}>
                                                <Typography sx={{ textAlign: "center", fontWeight: "600", py: 1, borderBottom: "1px solid #FFE6E9" }} >Total Marks</Typography>
                                                <Typography sx={{ textAlign: "center", fontWeight: "600", py: 1, borderBottom: "1px solid #FFE6E9" }} >Percentage</Typography>
                                                <Typography sx={{ textAlign: "center", fontWeight: "600", py: 1, borderBottom: "1px solid #FFE6E9" }} >Grade</Typography>
                                            </Box>
                                        </Grid>

                                        <Grid size={{ xs: 3.3 }} sx={{}}>
                                            <Box>
                                                <Typography sx={{ fontWeight: "600", py: 1, borderBottom: "1px solid #FFE6E9", color: "red" }} >296/300</Typography>
                                                <Typography sx={{ fontWeight: "600", py: 1, borderBottom: "1px solid #FFE6E9", color: "red" }} >98%</Typography>
                                                <Typography sx={{ fontWeight: "600", py: 1, borderBottom: "1px solid #FFE6E9", color: "red" }} >A1</Typography>
                                            </Box>
                                        </Grid>

                                    </Grid>
                                </Box>
                            </TableContainer>
                            <Grid container spacing={2} >
                                <Grid size={{ xs: 8 }}>
                                    <BarChart
                                        xAxis={[{ data: ['Tamil', 'English', 'Maths', 'Science', 'Social', 'Hindi'] }]}
                                        series={[{ data: [100, 100, 100, 100, 100, 100] }, { data: [98, 80, 60, 72, 88, 66] },]}
                                        height={250}
                                        barLabel="value"
                                        margin={{ left: 0 }}
                                        yAxis={[{ width: 30 }]}
                                    />
                                    <Grid container spacing={2} >
                                        <Grid size={{ xs: 6 }} sx={{ display: "flex", justifyContent: "center" }}>
                                            <Box sx={{ display: "flex" }}>
                                                <Box sx={{ backgroundColor: "#4858EE", width: "40px", height: "20px", mr: 2 }} />
                                                <Typography sx={{ fontSize: "14px" }}> Highest Mark</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid size={{ xs: 6 }} sx={{ display: "flex", justifyContent: "center" }}>
                                            <Box sx={{ display: "flex" }}>
                                                <Box sx={{ backgroundColor: "#FFB422", width: "40px", height: "20px", mr: 2 }} />
                                                <Typography sx={{ fontSize: "14px" }}> Scored Mark</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 4 }} sx={{ mt: 5 }}>
                                    <Box sx={{ textAlign: "center" }}>
                                        <Gauge
                                            value={marks}
                                            startAngle={0}
                                            endAngle={360}
                                            innerRadius="75%"
                                            outerRadius="100%"
                                            sx={{
                                                [`& .${gaugeClasses.valueText}`]: {
                                                    fontSize: 30,
                                                    fontWeight: 700,
                                                    fill: getColor(marks),
                                                },
                                                [`& .${gaugeClasses.valueArc}`]: {
                                                    fill: getColor(marks),
                                                },
                                                [`& .${gaugeClasses.referenceArc}`]: {
                                                    fill: '#E0E0E0',
                                                },
                                            }}
                                            text={({ value }) => `${value}%`}
                                        />

                                        <Typography
                                            variant="body2"
                                            sx={{
                                                mt: 1,
                                                color: "#555",
                                                fontWeight: 600,
                                                fontSize: "14px",
                                            }}
                                        >
                                            Scored Percentage
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>

                    <Paper ref={page2Ref} sx={{
                        width: "794px",
                        height: "1123px",
                        margin: "0 auto",
                        border: "1px solid #ccc",
                        overflow: "hidden",
                        border: "1px solid #ccc",
                        borderRadius: "0px",
                        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
                        my: 2
                    }}>
                        <Box p={3}>
                            <Typography
                                variant="subtitle1"
                                sx={{ mb: 1, fontWeight: 600, textAlign: "center" }}
                            >
                                EXAM-WISE MARKS SUMMARY
                            </Typography>

                            <TableContainer
                                sx={{
                                    mb: 2,
                                    border: "1px solid #D0130E",
                                    borderRadius: "3px",
                                    overflow: "hidden",
                                }}
                            >
                                <Table
                                    sx={{
                                        borderCollapse: "collapse",
                                        "& td, & th": {
                                            border: "1px solid #FFE6E9",
                                        },
                                    }}
                                >
                                    <TableHead sx={{ backgroundColor: "#FFF6F7" }}>
                                        <TableRow>
                                            <TableCell sx={{ color: "#000", fontWeight: 600 }}>#</TableCell>
                                            <TableCell sx={{ color: "#000", fontWeight: 600 }}>Exam</TableCell>
                                            <TableCell sx={{ color: "#000", fontWeight: 600 }}>Marks</TableCell>
                                            <TableCell sx={{ color: "#000", fontWeight: 600 }}>Grade</TableCell>
                                            <TableCell sx={{ color: "#000", fontWeight: 600 }}>Status</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {student.marks1.map((m, i) => {
                                            const isCompleted = m.score > 0;
                                            return (
                                                <TableRow
                                                    key={i}
                                                    sx={{
                                                        backgroundColor: isCompleted ? "#F5FFF5" : "#FAFAFA",
                                                        "&:hover": {
                                                            backgroundColor: isCompleted ? "#E8F5E9" : "#F0F0F0",
                                                        },
                                                    }}
                                                >
                                                    <TableCell>{i + 1}</TableCell>
                                                    <TableCell sx={{ fontWeight: isCompleted ? 600 : 400 }}>
                                                        {m.exam}
                                                    </TableCell>
                                                    <TableCell sx={{ color: isCompleted ? "green" : "#aaa" }}>
                                                        {`${m.score}/${m.total}`}
                                                    </TableCell>
                                                    <TableCell sx={{ color: isCompleted ? "#00467B" : "#999" }}>
                                                        {m.grade || "-"}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box
                                                            sx={{
                                                                display: "inline-block",

                                                                py: 0.3,
                                                                borderRadius: "15px",
                                                                fontSize: "12px",
                                                                fontWeight: 600,
                                                                backgroundColor: isCompleted ? "#C8E6C9" : "#FFEBEE",
                                                                color: isCompleted ? "#256029" : "#C62828",
                                                                textAlign: "center",
                                                                minWidth: "80px",
                                                            }}
                                                        >
                                                            {isCompleted ? "Completed" : "Pending"}
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Typography sx={{ fontWeight: "600", pb: 0.5 }} >Note</Typography>
                            <TextField
                                fullWidth

                                variant="outlined"
                                sx={{
                                    mb: 2,
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "#B78B9B",
                                            height: "80px"
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#B78B9B",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#B78B9B",
                                        },
                                    },
                                }}
                            />

                            <Grid container spacing={2} mt={2}>
                                <Grid size={{ xs: 4 }}>
                                    <Typography sx={{ fontWeight: "600" }} >Principal Signature</Typography>
                                    <Box
                                        sx={{
                                            border: "1px solid #B78B9B",
                                            borderRadius: "4px",
                                            height: "50px",
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >

                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 4 }}>
                                    <Typography sx={{ fontWeight: "600" }} > Class Teacher Signature</Typography>
                                    <Box
                                        sx={{
                                            border: "1px solid #B78B9B",
                                            borderRadius: "4px",
                                            height: "50px",
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >

                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 4 }}>
                                    <Typography sx={{ fontWeight: "600" }} >Parent's Signature</Typography>
                                    <Box
                                        sx={{
                                            border: "1px solid #B78B9B",
                                            borderRadius: "4px",
                                            height: "50px",
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >

                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>

                    <Box sx={{ display: "flex", justifyContent: "end", my: 2 }}>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={downloadPDF}
                            disabled={loading}
                        >
                            {loading ? "Generating PDF..." : "Download as PDF"}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
